import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const getDefaultState = () => {
  return {
    gDefaut: {
      gSession: null,
      gEtb_mag: '',
      gGpi_adh: '',
      gPic_adh: '',
      gGart_adh: 'N',
      gCod_metDefaut: 'VL',
      gLinkingTargetTypeDefaut: 'P',
      gPortailDefaut: 'portailVL',
      gLibellePortailDefaut: 'Pièces Auto',
      gIconPortailDefaut: 'piece',
      gPla_adh: '',
    },
    gInfoPanier: {
      gTotalQtePanier: '',
      gTotalMntPanier: '',
      gPanierArticles: [],   // ← AJOUT : liste des articles pour le header
    },
    gInfoVehicule: {
      gKtype: '',
      gImmat: '',
      gVin: '',
      gTyp: 'I',
      gTabInfoVeh: '',
      gVinReady: '',
    },
    gNavigation: {
      gParentNodeId: '',
      gIdTecdoc: '',
      gGenArt: '',
      gModeRech: '',
      gGroupName: '',
      gIdRaccourciGenart: '',
      gIdGcategorie: '',
    },
    gFicheArticle: {
      gArticleId: '',
      gParentNodeId: '',
      gId_tecdoc: '',
      gId_fitarfou: '',
      gReliability: '',
      gArticleNo: '',
      gId_fiadf: '',
      gBrandid: ''
    }
  };
};

export default createStore({
  state: getDefaultState(),
  getters: {},
  mutations: {
    // ─── Reset ────────────────────────────────────────────────────────────
    resetgInfoVehiculeState(state) { state.gInfoVehicule = getDefaultState().gInfoVehicule; },
    resetgNavigationState(state)   { state.gNavigation   = getDefaultState().gNavigation; },
    resetgInfoPanierState(state)   { state.gInfoPanier   = getDefaultState().gInfoPanier; },
    resetgDefautState(state)       { state.gDefaut        = getDefaultState().gDefaut; },
    resetgFicheArticle(state)      { state.gFicheArticle  = getDefaultState().gFicheArticle; },
    RESET_STATE(state)             { Object.assign(state, getDefaultState()); },

    // ─── Fiche article ────────────────────────────────────────────────────
    setgArticleId(state, value)        { state.gFicheArticle.gArticleId    = value; },
    setgParentNodeIdFiche(state, value){ state.gFicheArticle.gParentNodeId = value; },
    setgId_tecdoc(state, value)        { state.gFicheArticle.gId_tecdoc    = value; },
    setgId_fitarfou(state, value)      { state.gFicheArticle.gId_fitarfou  = value; },
    setgReliability(state, value)      { state.gFicheArticle.gReliability  = value; },
    setgArticleNo(state, value)        { state.gFicheArticle.gArticleNo    = value; },
    setgId_fiadf(state, value)         { state.gFicheArticle.gId_fiadf     = value; },
    setgBrandid(state, value)          { state.gFicheArticle.gBrandid      = value; },

    // ─── Navigation ───────────────────────────────────────────────────────
    setgParentNodeIdNavigation(state, value) { state.gNavigation.gParentNodeId = value; },
    setgIdTecdoc(state, value)               { state.gNavigation.gIdTecdoc     = value; },
    setgGenArt(state, value)                 { state.gNavigation.gGenArt        = value; },
    setgModeRech(state, value)               { state.gNavigation.gModeRech      = value; },
    setgGroupName(state, value)              { state.gNavigation.gGroupName     = value; },
    setgIdRaccourciGenart(state, payload) { state.gNavigation.gIdRaccourciGenart = payload; },
    setgIdGcategorie(state, payload) { state.gNavigation.gIdGcategorie = payload; },
    // ─── Panier ───────────────────────────────────────────────────────────
    setgTotalQtePanier(state, value) { state.gInfoPanier.gTotalQtePanier = value; },
    setgTotalMntPanier(state, value) { state.gInfoPanier.gTotalMntPanier = value; },

    // ← AJOUT : alimente le panneau panier du header (remplace sessionStorage)
    setPanierArticles(state, articles) {
      state.gInfoPanier.gPanierArticles = Array.isArray(articles) ? articles : [];
    },

    // ─── Défaut ───────────────────────────────────────────────────────────
    setgLibellePortailDefaut(state, value)    { state.gDefaut.gLibellePortailDefaut    = value; },
    setgSession(state, value)                 { state.gDefaut.gSession                 = value; },
    setgLinkingTargetTypeDefaut(state, value) { state.gDefaut.gLinkingTargetTypeDefaut = value; },
    setgPortailDefaut(state, value)           { state.gDefaut.gPortailDefaut           = value; },
    setgCod_metDefaut(state, value)           { state.gDefaut.gCod_metDefaut           = value; },

    // ─── Véhicule ─────────────────────────────────────────────────────────
    setgKtype(state, value)   { state.gInfoVehicule.gKtype       = value; },
    setgTyp(state, value)     { state.gInfoVehicule.gTyp         = value; },
    setgImmat(state, value)   { state.gInfoVehicule.gImmat       = value; },
    setgVin(state, value)     { state.gInfoVehicule.gVin         = value; },
    setgVinReady(state, value){ state.gInfoVehicule.gVinReady    = value; },
    setgInfoVeh(state, value) { state.gInfoVehicule.gTabInfoVeh  = value; },

    // ─── Adhérent ─────────────────────────────────────────────────────────
    setgGpi_adh(state, value) { state.gDefaut.gGpi_adh  = value; },
    setgPla_adh(state, value) { state.gDefaut.gPla_adh  = value; },
    setgPic_adh(state, value) { state.gDefaut.gPic_adh  = value; },
    setgGart_adh(state, value){ state.gDefaut.gGart_adh = value; },
    setgEtb_mag(state, value) { state.gDefaut.gEtb_mag  = value; },
  },
  actions: {
    resetState({ commit }) { commit('RESET_STATE'); }
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
});